export const POST_TYPES = {
  TWEET: 'tweet',
  REPLY_TWEET: 'reply-tweet',
  QUOTE_TWEET: 'quote-tweet',
  RETWEET: 'retweet',
  QUOTE_RETWEET: 'quote-retweet',
};

export const MEDIA_TWEET = 'media';
